import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MonthPickerComponent } from './month-picker.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  declarations: [MonthPickerComponent],
  exports: [MonthPickerComponent],
})
export class MonthPickerModule { }



// WEBPACK FOOTER //
// ./src/app/utils/month-picker/month-picker.module.ts